export default function DomainsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Custom Domains</h1>
      <div className="card p-6">
        <p className="text-gray-500">Custom domain management coming soon...</p>
      </div>
    </div>
  );
}
